import React from "react";
import {
    APPLICATION_FORM_FIELDS,
    CANADA_COUNTRY,
    COUNTRY,
    INVALID_DATES_ERROR_MESSAGE,
    DROPZONE_ACCEPTED_FILES_ARRAY,
} from "../../helpers/variables";
import AttachmentsList from "../General/attachmentsList";
import ApplicationQuestion from "./applicationQuestion";
import {isAragUser} from "../../helpers/functions";
import { 
    checkWhichQuestionTriggeredConditional, 
    checkIfQuestionsHasBeenModified, 
    checkDateTypeForForms 
} from "../../helpers/questions/functions";
import { FormGroup, HorizontalRule, Alert, Loader, Button, Heading, DragAndDrop } from 'arag-ui-lib';
import { FORM_GROUP_VARIANTS } from "../../helpers/formGroupVariants";
import moment from "moment";
import CONTENT_STRINGS from "../../helpers/contentStrings";
import { 
    PRIMARY, QUATERNARY, RIGHT, DATE_FORMAT, DOTS, PALE, MOMENT_DATE_FORMAT, 
    SUBMIT, ERROR, SUCCESS, MEDIUM, SOLICITOR, HEADING_3, DRAFT, EXTRA_OPPONENTS, 
    DUPLICATE,
} from "../../helpers/constants";
const FullApplicationForm = (props) => {
    const {
        Store,
        UserRole,
        breachCausationCp,
        checkIfQuestionIsEditable,
        HandleSave,
        HandleSubmit,
        ChangeNewAppField,
        HandleDateChange,
        HandleFormCompChange,
        OnDrop,
        AttachmentRemove,
        RemoveExtraOpponent,
        UpdateExtraOpponents,
        removeMedicalExpertFeesTableRow,
        updateMedicalExpertFees,
        onClickActionLink,
        requestApplicationAttachment,
        requestDeleteDocument,
        groupedQuestions,
        HandleSelectChange,
        maxDateOfBirth,
        workSourceOptions,
        user,
        handleMedicalFeesTableRows,
        application,
        mapEditingQuestionOrFieldToEditingSetting,
        openDeleteAnswerModal,
        openEditQuestionAnswerModal
    } = props;

    const isFileDisabled = ((Object.keys(Store.selectedApplication).length !== 0 && 
                            Store.selectedApplication.constructor === Object) && 
                            Store.selectedApplication.policyStatus !== DRAFT)

    return (
        <form className="form-horizontal" onSubmit={HandleSubmit} autoComplete="off">
            <FormGroup
                labelSize={'col-sm-3'}
                inputSize={'col-sm-6 formGroup-textInput-input-wrapper'}
                label={APPLICATION_FORM_FIELDS.SOLICITOR_REFERENCE.name}
                variant={FORM_GROUP_VARIANTS.TEXT}
                inputProps={{
                    id: APPLICATION_FORM_FIELDS.SOLICITOR_REFERENCE.fieldName,
                    name: "solicitorFileReference",
                    required: true,
                    label: Store.solicitorFileReference,
                    value: Store.solicitorFileReference,
                    onChange: (evt) => { ChangeNewAppField(evt.target.name, evt.target.value); },
                }}
                formGroupTestId={'new-application-SolicitorFileReference'}
            />
            {
                (workSourceOptions.length > 1 && COUNTRY != CANADA_COUNTRY)
                ?
                    <FormGroup 
                        labelSize={'col-sm-3'}
                        inputSize={'col-sm-6 formGroup-textInput-input-wrapper'}
                        label={APPLICATION_FORM_FIELDS.WORK_SOURCE.name}
                        variant={FORM_GROUP_VARIANTS.SELECT}
                        inputProps={{
                            id: APPLICATION_FORM_FIELDS.WORK_SOURCE.fieldName,
                            name: "workSourceId",
                            required: user.loggedInUser.requiredWorkSource,
                            label: Store.workSourceId,
                            value: Store.workSourceId,
                            onChange: (evt) => { ChangeNewAppField(evt.target.name, evt.target.value); },
                            options: workSourceOptions,
                        }}
                        formGroupTestId={'new-application-WorkSource'}
                    />
                :
                    null
            }
            <HorizontalRule variant={PALE} className="generalTab-hr"/>
            <FormGroup
                labelSize={'col-sm-3'}
                inputSize={'col-sm-6 formGroup-textInput-input-wrapper'}
                label={APPLICATION_FORM_FIELDS.CLIENT_NAME.name}
                variant={FORM_GROUP_VARIANTS.TEXT}
                inputProps={{
                    id: APPLICATION_FORM_FIELDS.CLIENT_NAME.fieldName,
                    name: "clientName",
                    required: true,
                    label: Store.clientName,
                    value: Store.clientName,
                    onChange: (evt) => { ChangeNewAppField(evt.target.name, evt.target.value); },
                }}
                formGroupTestId={'new-application-ClientName'}
            />
            <FormGroup
                labelSize={'col-sm-3'}
                inputSize={'col-sm-6 formGroup-textInput-input-wrapper'}
                label={APPLICATION_FORM_FIELDS.DATE_OF_BIRTH.name}
                variant={FORM_GROUP_VARIANTS.DATE}
                inputProps={{
                    id: APPLICATION_FORM_FIELDS.DATE_OF_BIRTH.fieldName,
                    label: Store.dateOfBirth,
                    required: true,
                    dateInputProps: {
                        name: "dateOfBirth",
                        onChange: (e) => { HandleDateChange("dateOfBirth", moment(e).format(MOMENT_DATE_FORMAT), null, maxDateOfBirth); },
                        minDate: null,
                        maxDate: maxDateOfBirth,
                        autoComplete: 'off',
                        dateFormat: DATE_FORMAT,
                        placeholderText: CONTENT_STRINGS.DATE_PLACEHOLDER,
                        selected: checkDateTypeForForms(Store.dateOfBirth),
                        value: checkDateTypeForForms(Store.dateOfBirth),
                    },
                    errorMessage: INVALID_DATES_ERROR_MESSAGE,
                }}
                formGroupTestId={'new-application-DateOfBirth'}
            />
            <FormGroup
                labelSize={'col-sm-3'}
                inputSize={'col-sm-6 formGroup-textInput-input-wrapper'}
                label={APPLICATION_FORM_FIELDS.ADDRESS.name}
                variant={FORM_GROUP_VARIANTS.TEXT}
                inputProps={{
                    id: APPLICATION_FORM_FIELDS.ADDRESS.fieldName,
                    name: "address",
                    required: true,
                    label: Store.address,
                    value: Store.address,
                    onChange: (evt) => { ChangeNewAppField(evt.target.name, evt.target.value); },
                }}
                formGroupTestId={'new-application-Address'}
            />
            <FormGroup
                labelSize={'col-sm-3'}
                inputSize={'col-sm-6 formGroup-textInput-input-wrapper'}
                label={APPLICATION_FORM_FIELDS.POST_CODE.name}
                variant={FORM_GROUP_VARIANTS.TEXT}
                inputProps={{
                    id: APPLICATION_FORM_FIELDS.POST_CODE.fieldName,
                    name: "postCode",
                    required: true,
                    label: Store.postCode,
                    value: Store.postCode,
                    onChange: (evt) => { ChangeNewAppField(evt.target.name, evt.target.value); },
                }}
                formGroupTestId={'new-application-PostCode'}
            />
            {
                Object.keys(groupedQuestions).map( (key, index) => {
                    return <React.Fragment key={key}>
                        <HorizontalRule variant={PALE} className="generalTab-hr"/>
                        {
                            groupedQuestions[key]
                                .map((question, index) => {
                                    const isLabelClickable = checkIfQuestionsHasBeenModified( null, application, question.id )
                                    return (
                                        <ApplicationQuestion
                                            opponentQuestions={Store.opponentQuestions}
                                            onOpponentAdd={() => ChangeNewAppField(EXTRA_OPPONENTS, [...Store.extraOpponents, {
                                                name: '',
                                                prospectsOptionId: '',
                                                insuredOptionId: '',
                                                satisfiedOptionId: ''
                                            }])}
                                            removeExtraOpponent={RemoveExtraOpponent}
                                            extraOpponents={Store.extraOpponents}
                                            updateExtraOpponents={UpdateExtraOpponents}
                                            removeMedicalExpertFeesTableRow={removeMedicalExpertFeesTableRow}
                                            handleMedicalFeesTableRows={handleMedicalFeesTableRows}
                                            isPlain={false}
                                            medExpertFees={Store.medExpertFees}
                                            updateMedicalExpertFees={updateMedicalExpertFees}
                                            breachCausationCp={breachCausationCp}
                                            fileDisabled={isFileDisabled}
                                            onDrop={OnDrop}
                                            handleDateChange={HandleDateChange}
                                            questions={Store.questions}
                                            key={question.id}
                                            textAreaRows={8}
                                            question={question}
                                            formData={Store.formData}
                                            handleSelectChange={HandleSelectChange}
                                            handleTextInputChange={HandleFormCompChange}
                                            onClickActionLink={onClickActionLink}
                                            attachments={Store.attachments}
                                            checkIfQuestionIsEditable={checkIfQuestionIsEditable}
                                            isLabelClickable={isLabelClickable}
                                            mapEditingQuestionOrFieldToEditingSetting={mapEditingQuestionOrFieldToEditingSetting}
                                            isEditModalOpen={Store.questionAnswerModalOpen}
                                            openDeleteAnswerModal={openDeleteAnswerModal}
                                            application={application}
                                            isApplicationTab={true}
                                            openEditQuestionAnswerModal={openEditQuestionAnswerModal}
                                        />
                                    );
                                }
                            )
                        }
                        {Store.triggeredQuestionsToDisplay && Store.triggeredQuestionsToDisplay.map(conditionalQuestion => {
                           const isLabelClickable = checkIfQuestionsHasBeenModified( null, application, conditionalQuestion.id )
                           var triggerQuestionsGroupIds = checkWhichQuestionTriggeredConditional(Store.formData,Store.questions,conditionalQuestion);
                           var istriggered = triggerQuestionsGroupIds.length > 0 && conditionalQuestion.groupSortOrder == key;
                            if (istriggered) {
                                return (
                                    <ApplicationQuestion
                                        isPlain={false}
                                        onDrop={OnDrop}
                                        onClickActionLink={onClickActionLink}
                                        handleDateChange={HandleDateChange}
                                        questions={Store.questions}
                                        key={conditionalQuestion.id}
                                        textAreaRows={8}
                                        question={conditionalQuestion}
                                        formData={Store.formData}
                                        handleSelectChange={HandleSelectChange}
                                        handleTextInputChange={HandleFormCompChange}
                                        fileDisabled={isFileDisabled}
                                        attachments={Store.attachments}
                                        checkIfQuestionIsEditable={checkIfQuestionIsEditable}
                                        updateMedicalExpertFees={updateMedicalExpertFees}
                                        isLabelClickable={isLabelClickable}
                                        mapEditingQuestionOrFieldToEditingSetting={mapEditingQuestionOrFieldToEditingSetting}
                                        isEditModalOpen={Store.questionAnswerModalOpen}
                                        openDeleteAnswerModal={openDeleteAnswerModal}
                                        application={application}
                                        isApplicationTab={true}
                                        openEditQuestionAnswerModal={openEditQuestionAnswerModal}
                                    />
                                )
                            }
                        })}
                    </React.Fragment>
                })
            }
            {
                (!Store.duplicate)
                ?
                    <div className="form-group">
                        <div className="col-sm-3"> </div>
                        <div className="col-sm-6">
                            {!isAragUser(user.loggedInUser.roles) ?
                                <Button 
                                    onClick={HandleSave}
                                    variant={QUATERNARY}
                                    label={CONTENT_STRINGS.SAVE_PROGRESS}
                                    arrowDirection={RIGHT}
                                    buttonTestId={'new-application-SaveProgressButton'}
                                    disabled={Store.posting}
                                />
                                : null
                            }
                            {UserRole === SOLICITOR || isAragUser(user.loggedInUser.roles) 
                            ?
                                <Button 
                                    type={SUBMIT}
                                    variant={PRIMARY}
                                    label={CONTENT_STRINGS.SUBMIT_APPLICATION}
                                    arrowDirection={RIGHT}
                                    buttonTestId={'new-application-SubmitButton'}
                                    disabled={Store.posting}
                                />
                            :
                                null
                            }
                            {Store.posting 
                            ?
                                <div className="form-group">
                                    <div className="col-sm-12"><Loader variant={DOTS} dotSize={MEDIUM}/></div>
                                </div>
                            : 
                                null
                            }
                        </div>
                    </div>
                :
                    <div>
                        <FormGroup
                            labelSize={'col-sm-3'}
                            inputSize={'col-sm-6 formGroup-textInput-input-wrapper'}
                            label={CONTENT_STRINGS.CONFIRMATION}
                            variant={FORM_GROUP_VARIANTS.TEXT}
                            inputProps={{
                                name: 'confirmation',
                                required: true,
                                onChange: (evt) => { ChangeNewAppField(evt.target.name, evt.target.value); },
                                required: true,
                                value: Store.confirmation
                            }}
                            formGroupTestId={'new-application-ConfirmationField'}

                        />
                        <div className="form-group">
                            <div className='col-sm-3'></div>
                            <div style={{display: 'flex', flexDirection: 'row', gap: '5px'}} className="col-sm-6">
                                <Button
                                    onClick={() => { ChangeNewAppField(DUPLICATE, false); }}
                                    variant={QUATERNARY}
                                    label={CONTENT_STRINGS.CANCEL}
                                    arrowDirection={RIGHT}
                                    buttonTestId={'new-application-CancelButton'}
                                />
                                <Button
                                    type={SUBMIT}
                                    variant={QUATERNARY}
                                    label={CONTENT_STRINGS.SAVE_PROGRESS}
                                    arrowDirection={RIGHT}
                                    buttonTestId={'new-application-SaveProgressButton'}
                                   disabled={Store.posting}
                                />
                            </div>
                        </div>
                    </div>
            }
            {Store.badMsg !== ''
            ?
                <div className="col-sm-12">
                    <div className="col-sm-3"></div>
                    <div  className="col-sm-6">
                        <Alert variant={ERROR} label={Store.badMsg} />
                    </div>
                </div>
            :
                null
            }
            {Store.msg !== ''
            ?
                <div className="col-sm-12">
                    <div className="col-sm-3"></div>
                    <div  className="col-sm-6">
                        <Alert variant={SUCCESS} label={Store.msg} />
                    </div>
                </div>
            :
                null
            }
            <div className="form-group">
                <div className="col-sm-6 col-sm-offset-3">
                    <div>
                        <DragAndDrop
                            label={CONTENT_STRINGS.UPLOAD_FILE_TOOLTIP}
                            accepts={DROPZONE_ACCEPTED_FILES_ARRAY}
                            allowMultiple={true}
                            onDrop={(files) => OnDrop(files)}
                            required={false}
                            ddTestId={'new-application-DragAndDrop'}
                        />
                    </div>
                    <AttachmentsList
                        attachments={Store.attachments || []}
                        onAttachmentRemove={(attachment, index) => AttachmentRemove(index)}
                    />
                    {
                        Store.attachmentsForDisplay.length > 0 
                        ?
                            <div>
                                <div className="row">
                                    <div className="col-sm-12">
                                        <HorizontalRule variant={PALE} className="appFormRefSettings-hr"/>
                                    </div>
                                </div>
                                <div className="col-sm-12">
                                    <Heading variant={HEADING_3} title={CONTENT_STRINGS.FILES_ALREADY_ATTACHED} />
                                </div>
                                <AttachmentsList
                                    onAttachmentRequest={(attachment) => {
                                        requestApplicationAttachment({
                                            applicationId: Store.selectedApplication.id,attachmentId:attachment.id,
                                            relativeUrl: attachment.relativeUrl
                                        });
                                    }}
                                    attachments={Store.attachmentsForDisplay}
                                    onAttachmentRemove={(attachment) => requestDeleteDocument(Store.patchedApplication.id, attachment.id, attachment.relativeUrl)}
                                />
                            </div>
                        :
                            null
                    }
                </div>
            </div>
        </form>
    )
};

export default FullApplicationForm;